<template>
  <SfButtonDs variant="secondary" @click="switchToPreparationMode">
    <span class="tw-flex tw-items-center tw-gap-2">
      <span>{{ copy.presenting }}</span>
      <SfToggle :model-value="isPresenting" :icons="false" @click.prevent />
    </span>
  </SfButtonDs>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { SfButtonDs } from '@silverfin/ui-components'
import SfToggle from '@app/shared/vue/components/sf-toggle.vue'
import * as PrepareApi from '@app/application/client_meetings/api/prepare'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfLog } from '@app/adapters/logger'

defineOptions({ name: 'PresentingToggle' })

const I18n = useI18n()
const copy = {
  presenting: I18n.t('client_meetings.present.presenting'),
}

const isPresenting = ref(true)

async function switchToPreparationMode() {
  // One click on the label reaches this button twice, through the label and the checkbox it forwards to
  if (!isPresenting.value) return

  isPresenting.value = false
  try {
    await PrepareApi.disablePresentationMode()

    window.Turbolinks.visit(window.location.href)
  } catch (error) {
    SfLog.error('Failed to disable presentation mode', { error })
    isPresenting.value = true
  }
}
</script>
